import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { UserCohortDto } from '../../../models/user-cohort/dto/user-cohort.dto';

export const GET_USER_COHORTS_QUERY_KEY = (
  userId: string,
  organizationId: string,
) => ['cohorts', organizationId, 'user', userId];

export function useGetUserCohorts(userId?: string, organizationId?: string) {
  const apiClient = useApiClient();

  return useQuery<UserCohortDto[]>({
    enabled: Boolean(userId && organizationId),
    queryKey: GET_USER_COHORTS_QUERY_KEY(userId!, organizationId!),
    queryFn: async (): Promise<UserCohortDto[]> => {
      const response = await apiClient.fetchApi<UserCohortDto[], {}>({
        method: 'GET',
        endpoint: `cohorts?organizationId=${organizationId}&userId=${userId}`,
      });
      return response;
    },
  });
}
